import React from 'react';

import LinkIcon from '@atlaskit/icon/core/link';
import { token } from '@atlaskit/tokens';

import type { BylineConnectionIcon } from './getBylineConnectionIcons.ts';

// Shared by the loading placeholder and the loaded stack's padding.
export const createPlaceholderConnectionIcon = (index: number): BylineConnectionIcon => ({
	key: `placeholder-link-${index}`,
	label: '',
	icon: {
		kind: 'element',
		key: `placeholder-link-${index}`,
		label: '',
		node: (
			<LinkIcon
				label=""
				color={token('color.icon.disabled')}
				testId="byline-connections-ssr-placeholder-icon"
			/>
		),
	},
});
